import React, { useState } from "react";
import API from "../../config/api";
import { useAuth } from "../../hooks/useAuth";

export default function LoginPage() {
  const { login } = useAuth();
  const [step, setStep] = useState("form");
  const [form, setForm] = useState({ name: "", email: "", mobile: "" });
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  const sendOtp = async () => {
    if (!form.name || !form.email || !form.mobile) { setError("All fields are required"); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch(API.register, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.message || "Failed to send OTP");
      setInfo("OTP sent to your email"); setStep("otp");
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const verifyOtp = async () => {
    if (!otp) { setError("Enter OTP"); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch(API.verifyOtp, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: form.email, otp }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.message || "Invalid OTP");
      login(data.token, data.user);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.logo}>
          <span style={{ color: "#FF9900", fontSize: 28, fontWeight: "bold" }}>DigiTran</span>
          <span style={{ color: "#fff", fontSize: 18, marginLeft: 8 }}>Voice AI</span>
        </div>
        <p style={S.subtitle}>AI-powered voice call platform for your business</p>

        {step === "form" ? (
          <>
            <input style={S.input} placeholder="Full Name" value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })} />
            <input style={S.input} placeholder="Email Address" type="email" value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })} />
            <input style={S.input} placeholder="Mobile (+91XXXXXXXXXX)" value={form.mobile}
              onChange={e => setForm({ ...form, mobile: e.target.value })} />
            <button style={S.btn} onClick={sendOtp} disabled={loading}>
              {loading ? "Sending OTP..." : "Get OTP"}
            </button>
          </>
        ) : (
          <>
            <p style={{ color: "#aaa", fontSize: 13, marginBottom: 12 }}>
              OTP sent to <strong style={{ color: "#fff" }}>{form.email}</strong>
            </p>
            <input style={S.input} placeholder="Enter 6-digit OTP" value={otp}
              onChange={e => setOtp(e.target.value)} maxLength={6} />
            <button style={S.btn} onClick={verifyOtp} disabled={loading}>
              {loading ? "Verifying..." : "Verify & Login"}
            </button>
            <button style={S.linkBtn} onClick={() => { setStep("form"); setError(""); setOtp(""); }}>
              ← Change details
            </button>
          </>
        )}
        {info && <p style={S.info}>{info}</p>}
        {error && <p style={S.error}>{error}</p>}
      </div>
    </div>
  );
}

const S = {
  page: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0d1117" },
  card: { background: "#161b22", borderRadius: 12, padding: "40px 36px", width: 380, border: "1px solid #30363d" },
  logo: { textAlign: "center", marginBottom: 8 },
  subtitle: { color: "#8b949e", fontSize: 13, textAlign: "center", marginBottom: 28 },
  input: { width: "100%", padding: "10px 14px", marginBottom: 12, background: "#0d1117", border: "1px solid #30363d", borderRadius: 8, color: "#fff", fontSize: 14, boxSizing: "border-box" },
  btn: { width: "100%", padding: 12, background: "#FF9900", border: "none", borderRadius: 8, color: "#000", fontWeight: "bold", fontSize: 15, cursor: "pointer", marginTop: 4 },
  linkBtn: { width: "100%", padding: 8, background: "transparent", border: "none", color: "#58a6ff", cursor: "pointer", fontSize: 13, marginTop: 8 },
  info: { color: "#3fb950", fontSize: 13, textAlign: "center", marginTop: 12 },
  error: { color: "#f85149", fontSize: 13, textAlign: "center", marginTop: 12 },
};
